import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import { useLabels } from 'wsm-common-data';
import AspectRatioBox from './aspect-ratio-box/AspectRatioBox';
import DetailsButton from './DetailsButton';
import OptimizedImage from './OptimizedImage';
import { aR, aspectRatiosProportions } from '../global-constants';
import { getCouponStatus } from '../utilities/aspect';
import { getQueryStringValue } from '../utilities/utility';
import { useURLPrefs } from '../hooks/useURLPrefs';

const Asset = ({
	imageUrl,
	isMobile = false,
	isVisible = true,
	promo = {},
	title,
	carouselPosition,
	width,
	incentive,
	pushOutsiderButton
}) => {
	const { aspectRatio, enableCarousel } = useURLPrefs();
	const labels = useLabels();
	const [widthProportion, heightProportion] =
		aspectRatiosProportions.get(aspectRatio);
	const isCoupon = getCouponStatus(aspectRatio);
	const isCouponCaro = enableCarousel === 'true' && isCoupon;

	let altText = getQueryStringValue(imageUrl, 'altText');
	if (altText) {
		altText = decodeURIComponent(altText);
	}
	const imgUrl = new URL(imageUrl);

	// Render disclaimer inside promo card all aspect ratios expect 10x1 and 6x1
	const showDisclaimerBtn =
		aspectRatio === aR.DESKTOP_4X1 ||
		aspectRatio === aR.DESKTOP_4X3 ||
		aspectRatio === aR.MOBILE_4X3_SLIDESHOW ||
		aspectRatio === aR.MOBILE_4X3_COUPON;

	const renderDisclaimerButton = (
		<div
			className={setClassNames([
				'asset-disclaimer',
				'absolute-bottom',
				'absolute-left',
				'disclaimer-on-aspect-ratio-box'
			])}
		>
			<DetailsButton
				btnStyle="link"
				carouselPosition={carouselPosition}
				customAsset
				classes={[
					setClassNames([
						showDisclaimerBtn ? 'mx-3 text-black' : '',
						'my-1',
						'btn-no-decoration',
						'font-weight-normal'
					])
				]}
				isVisible={isVisible}
				listingConfigId=""
				promo={promo}
				incentive={incentive}
				fullLabel
			/>
		</div>
	);

	useEffect(() => {
		if (isVisible) {
			pushOutsiderButton(
				// this happens on Mobile6x1 and Desktop10x1
				!showDisclaimerBtn ? renderDisclaimerButton : null
			);
		}

		return () => {
			pushOutsiderButton(null);
		};
	}, [isVisible]);

	return (
		<AspectRatioBox
			aspectRatio={{ width: widthProportion, height: heightProportion }}
		>
			<OptimizedImage
				className={`custom-asset ${
					isCouponCaro && !isMobile ? 'p-3' : ''
				}`}
				alt={altText || title}
				src={imgUrl.href}
				width={width}
			/>
			<p className='sr-only'>{promo?.ctaConfig?.openInNewTab ? labels.get('OPEN_IN_NEW_TAB') : labels.get('OPEN_IN_SAME_TAB')}</p>
			{showDisclaimerBtn ? renderDisclaimerButton : null}
		</AspectRatioBox>
	);
};

Asset.propTypes = {
	carouselPosition: PropTypes.number.isRequired,
	pushOutsiderButton: PropTypes.func.isRequired,
	imageUrl: PropTypes.string.isRequired,
	isMobile: PropTypes.bool,
	isVisible: PropTypes.bool,
	promo: PropTypes.shape({}).isRequired,
	title: PropTypes.string.isRequired,
	width: PropTypes.number.isRequired,
	incentive: PropTypes.shape({})
};

export default Asset;
